import { Page } from 'ts/types/Page'
import {
  UserAddPage,
  UserTypeAddPage
} from 'pages/Main'

const routes: Page[] = [
  {
    routeName: '/user/add',
    component: UserAddPage
  },
  {
    routeName: '/user-type/add',
    component: UserTypeAddPage
  }
]

export default routes
